import React from 'react';
import InlineDialog from '../InlineDialog';
import Button from 'kingpin/atoms/Button';

import FilterPlateForm from '../FilterPlateForm';

const AddFilterPlateButton = ({
  isOpen,
  open,
  close,
  isShowingLabel,
  isScope,
  onManualFilterChanged,
  onFilterAdded,
  testIdPrefix,
  label,
  isDisabled,
  isDateScopeDisabled,
}: {
  isOpen: boolean;
  open: () => void;
  close: () => void;
  isShowingLabel: boolean;
  isScope: boolean;
  onManualFilterChanged?: () => void;
  onFilterAdded?: () => void;
  testIdPrefix?: string;
  label?: string;
  isDisabled?: boolean;
  isDateScopeDisabled?: boolean;
}) => (
  <div>
    <InlineDialog
      isOpen={isOpen}
      onClose={close}
      content={
        <FilterPlateForm
          close={close}
          isScope={isScope}
          onManualFilterChanged={onManualFilterChanged}
          onFilterAdded={onFilterAdded}
          isDateScopeDisabled={isDateScopeDisabled}
        />
      }
    >
      {/* Without its label, named on hover */}
      <span title={isShowingLabel ? undefined : label || 'Add Filter'}>
        <Button
          isDisabled={isDisabled}
          onClick={isOpen ? close : open}
          testId={testIdPrefix ? `${testIdPrefix}-add-filter` : 'add-filter'}
          type="Secondary"
          label={!isShowingLabel ? undefined : label ? label : 'Add Filter'}
          size="Small"
          icon="filters"
        />
      </span>
    </InlineDialog>
  </div>
);

export default AddFilterPlateButton;
